import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "./ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export default function TablePagination({ page, setPage, perPage, setPerPage, total }) {
  const pages = Math.max(1, Math.ceil(total / perPage));
  const start = total === 0 ? 0 : (page - 1) * perPage + 1;
  const end = Math.min(page * perPage, total);
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 border-t bg-slate-50/70 text-sm">
      <p className="text-muted-foreground text-xs" data-testid="pagination-info">
        Menunjukkan <b>{start}–{end}</b> daripada <b>{total}</b> rekod
      </p>
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <span className="text-xs text-muted-foreground">Baris:</span>
          <Select value={String(perPage)} onValueChange={(v) => { setPerPage(Number(v)); setPage(1); }}>
            <SelectTrigger className="h-8 w-[70px]" data-testid="per-page-select"><SelectValue /></SelectTrigger>
            <SelectContent className="bg-white">
              {[10, 25, 50, 100].map((n) => <SelectItem key={n} value={String(n)}>{n}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="flex items-center gap-1.5">
          <Button variant="outline" size="icon" className="h-8 w-8" disabled={page <= 1} onClick={() => setPage(page - 1)} data-testid="prev-page-btn">
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <span className="px-1.5 text-xs font-semibold whitespace-nowrap">{page} / {pages}</span>
          <Button variant="outline" size="icon" className="h-8 w-8" disabled={page >= pages} onClick={() => setPage(page + 1)} data-testid="next-page-btn">
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
